module.exports = __webpack_public_path__ + "static/img/07.5de5a6b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/familybuilding/07.jpg
// module id = n8QF
// module chunks = 0